import { createApp } from "vue";
import App from "./App.vue";
import { NativeAudio } from "@capgo/native-audio";

async function init() {
	window.bgVolume = {
		vol: 0.3,
	};
	window.bgAudio = true;
	try {
		await NativeAudio.preload({
			assetId: "bgMusic",
			assetPath: "audio/background.mp3",
			audioChannelNum: 1,
			isUrl: false,
			volume: window.bgVolume.vol,
		});

		NativeAudio.configure({
			assetId: "bgMusic",
			fade: true,
		});

		await NativeAudio.preload({
			assetId: "click",
			assetPath: "audio/click.wav",
			audioChannelNum: 2,
			isUrl: false,
		});
	} catch (error) {
		console.log("ERR LOADING AUDIO");
	}

	const app = createApp(App);
	app.mount("#app");
}

init();
